import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ProjectPerson {
  id: number;
  name: string;
  relationship: string;
}

export interface TaxProject {
  id: number;
  name: string;
  taxYear: number;
  filingStatus: string | null;
  persons: ProjectPerson[];
  documentCount: number;
  isDefault: boolean;
  createdAt: string | null;
}

export interface ProjectsState {
  projects: TaxProject[];
  activeProjectId: number | null;
  loading: boolean;
}

const initialState: ProjectsState = {
  projects: [],
  activeProjectId: null,
  loading: false,
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setProjects: (state, action: PayloadAction<TaxProject[]>) => {
      state.projects = action.payload;
      // Auto-select default project if none selected
      if (!state.activeProjectId && action.payload.length > 0) {
        const defaultProject = action.payload.find((p) => p.isDefault);
        state.activeProjectId = defaultProject?.id || action.payload[0].id;
      }
    },

    setActiveProject: (state, action: PayloadAction<number>) => {
      state.activeProjectId = action.payload;
    },

    addProject: (state, action: PayloadAction<TaxProject>) => {
      state.projects.push(action.payload);
    },

    updateProject: (state, action: PayloadAction<TaxProject>) => {
      const idx = state.projects.findIndex((p) => p.id === action.payload.id);
      if (idx !== -1) state.projects[idx] = action.payload;
    },

    removeProject: (state, action: PayloadAction<number>) => {
      state.projects = state.projects.filter((p) => p.id !== action.payload);
      if (state.activeProjectId === action.payload) {
        state.activeProjectId = state.projects[0]?.id || null;
      }
    },

    setProjectsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setProjects,
  setActiveProject,
  addProject,
  updateProject,
  removeProject,
  setProjectsLoading,
} = projectsSlice.actions;

export default projectsSlice.reducer;
